import { render, staticRenderFns } from "./terms-of-condition.html?vue&type=template&id=2ef6babc&scoped=true&"
import script from "./terms-of-condition.js?vue&type=script&lang=js&"
export * from "./terms-of-condition.js?vue&type=script&lang=js&"
import style0 from "./terms-of-condition.css?vue&type=style&index=0&id=2ef6babc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef6babc",
  null
  
)

export default component.exports